import Marquee from "react-fast-marquee";

const words = ["Branding", "Web", "SEO", "Content", "AI", "Video", "Marketing", "Copy", "Social"];

export const EditorialMarquee = () => (
  <div data-testid="editorial-marquee" className="py-14 md:py-20 border-y border-black/5 bg-white overflow-hidden">
    <Marquee speed={35} autoFill gradient={false}>
      {words.map((w, i) => (
        <span key={w} className="mx-6 md:mx-10 flex items-center gap-12 md:gap-20">
          <span className={`font-display font-black tracking-tighter text-5xl md:text-8xl ${i % 2 === 0 ? "text-stroke" : "text-[#0A0A0A]"}`}>
            {w}
          </span>
          <span className="w-3 h-3 md:w-4 md:h-4 rounded-full bg-[#0047FF]" />
        </span>
      ))}
    </Marquee>
  </div>
);
